class ProductMainGrid extends HTMLElement{
  constructor(){
    super();
    this.ext_components();
  }
  ext_components(){
    var mainObj = this;
    this.gallerySlider();
    this.variantFieldSets();
    this.stickyCart(mainObj);
    this.cookieSizeSelector(mainObj);
    if(this.querySelector('.makeItDropForMobile')){ this.querySelector('.makeItDropForMobile').addEventListener('click', (e) => this.drawerMobileInit(mainObj,e)); };
    if(this.querySelector('.DropdownCross')){ this.querySelector('.DropdownCross').addEventListener('click', (e) => this.drawerMobileClose(mainObj,e)); };
    if(this.querySelectorAll('.triggerClick').length > 0){ this.querySelectorAll('.triggerClick').forEach(function(measure){measure.addEventListener('click', (e) => mainObj.howToMeasureInit(mainObj,e));}); };
    if(document.querySelector('.OnClick-cross-popup')){ document.querySelector('.OnClick-cross-popup').addEventListener('click', (e) => this.howToMeasureClose(mainObj,e)) };
    if(this.querySelectorAll('.FormProduct form').length > 0){ this.querySelectorAll('.FormProduct form').forEach(function(form){ form.addEventListener('submit', (e) => mainObj.formSubmitAJAX(mainObj,e)) }) }
    if(document.querySelector('.cv_sticky_atc_button')){ document.querySelector('.cv_sticky_atc_button').addEventListener('click', (e) => mainObj.stickyFormSubmitAJAX(mainObj,e)) }
    if(this.querySelectorAll('.Know-size .SelectorOuter .brad-name-here').length > 0){
      this.querySelectorAll('.Know-size .SelectorOuter .brad-name-here').forEach(function(select){ select.addEventListener('change', (e) => mainObj.knowSizeSelect(mainObj,e)) })
    }
    if(this.querySelectorAll('.Know-size .SelectorOuter .First-brad-name-here').length > 0){
      this.querySelectorAll('.Know-size .SelectorOuter .First-brad-name-here').forEach(function(select){ select.addEventListener('change', (e) => mainObj.knowSizeSelect(mainObj,e)) })
    }
    if(this.querySelectorAll('.SecondOption').length > 0){ this.querySelectorAll('.SecondOption').forEach(function(select){ select.addEventListener('change', (e) => mainObj.knowSizeSecondSelect(mainObj,e)) }) }
    if(this.querySelectorAll('.SizeChartTitle').length > 0){ this.querySelectorAll('.SizeChartTitle').forEach(function(size){ size.addEventListener('click',(e) => mainObj.sizeChartPop(mainObj,e)) }) }
    if(document.querySelector('.SizeClosePop')){ document.querySelector('.SizeClosePop').addEventListener('click', (e) => mainObj.closeSize(mainObj,e)) }
  }
  gallerySlider(){
    var PDPMNThumbSliderChange, PDPMNSliderChange;
    if(PDPMNThumbSliderChange == undefined){
      if(window.innerWidth > 768){
        PDPMNThumbSliderChange = new Swiper(".MediaSliderThumbInit.swiper.mySwiper", {
          spaceBetween: 6,
          slidesPerView: 9,
          direction: "vertical",
          on: {
            init: (swiper) => {
              let totalGap = swiper.passedParams.spaceBetween * (swiper.passedParams.slidesPerView - 1);
              // let containerHeight = swiper.passedParams.slidesPerView * swiper.slides[0].clientHeight + totalGap;
              let containerHeight  = document.querySelector('.MediaSliderMNwrpr').clientHeight;
              swiper.el.style.height = containerHeight + 'px';
            }
          },
          mousewheel: true
        });
      }
    }
    if(PDPMNSliderChange == undefined){
      PDPMNSliderChange = new Swiper(".MediaSliderMNInit.swiper.mySwiper", {
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", },
        thumbs: { swiper: PDPMNThumbSliderChange, }
      });
    }
  }
  formSubmitAJAX(mainObj, target){
    target.preventDefault();
    let addToCartForm = mainObj.querySelector('.FormProduct form[action$="/cart/add"]');
    let formData = new FormData(addToCartForm);
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
    .then(response => { return response.json(); })
    .finally((error) => { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true })); });
  }
  cookieSizeSelector(mainObj){
    var KnowSizeVal, DontKnowSizeVal, KnowOpt1, KnowOpt2, KnowOpt3, DontKnowOpt1, DontKnowOpt2, DontKnowOpt3, firstVal, secondVal, eventFire = new Event("change", { bubbles: true });
    document.cookie.split(';').forEach(function (cookie) {
      const [rawKey, rawValue] = cookie.split('=');
      if (!rawKey || !rawValue) return;
      const key = rawKey.trim();
      const value = rawValue.trim();
      if (key === 'KnowSizeValue') {
        KnowSizeVal = value;
      }
      if (key === 'DontKnowSizeValue') {
        DontKnowSizeVal = value;
      }
    });
    
    if(KnowSizeVal != 'undefined' && KnowSizeVal != undefined){
      KnowOpt1 = KnowSizeVal.split('+')[0], KnowOpt2 = KnowSizeVal.split('+')[1].split('@')[0], KnowOpt3 = KnowSizeVal.split('@')[1];
      document.querySelectorAll('.Know-size [data-id="tab1"]').forEach(function(tab){
        if( tab.querySelector('.FirstOption option[value="'+KnowOpt1+'"]') && tab.querySelector('.SecondOption option[value="'+KnowOpt2+'"]') ){
          tab.querySelector('.FirstOption option[value="'+KnowOpt1+'"]').selected = true;
          tab.querySelector('.SecondOption option[value="'+KnowOpt2+'"]').selected = true;
          tab.querySelector('.ThirdOptionKnowSize option[data-get="'+KnowOpt1+'+'+KnowOpt2+'"]').selected = true;
          // document.querySelectorAll('.variant-input-wrap[data-index="option2"] input[value="'+KnowOpt3+'"]').forEach(function(input){
          //   input.dispatchEvent(eventFire);
          // })
        }
      })
      document.querySelectorAll('.Know-size').forEach(function(tab){ 
        tab.querySelector('.tab-button.tab1').classList.add('active');
        tab.querySelector('.tab-button.tab2').classList.remove('active');
        tab.querySelector('[data-id="tab1"]').style.display='block';
        tab.querySelector('[data-id="tab2"]').style.display='none';
      })

      mainObj.querySelectorAll('.FormProduct form').forEach(function(form){
        if(!form.querySelector('[name="properties[_Size Calculator]"]')){
          form.innerHTML += '<input type="hidden" name="properties[_Size Calculator]" value="yes">';
        }
        if(!form.querySelector('[name="properties[_Traditional Calculator]"]')){
          form.innerHTML += '<input type="hidden" name="properties[_Traditional Calculator]" value="yes">';
        }
        if(!form.querySelector('[name="properties[_Size selected]"]')){
          form.innerHTML += '<input type="hidden" name="properties[_Size selected]" value="'+KnowOpt1+'+'+KnowOpt2+'='+KnowOpt3+'">'
        }
      })
    }
    if(DontKnowSizeVal != 'undefined' && DontKnowSizeVal != undefined){
      DontKnowOpt1 = DontKnowSizeVal.split('+')[0], DontKnowOpt2 = DontKnowSizeVal.split('+')[1].split('@')[0], DontKnowOpt3 = DontKnowSizeVal.split('@')[1];
      document.querySelectorAll('.Know-size [data-id="tab2"]').forEach(function(tab){
        if( tab.querySelector('.FirstOption option[value="'+DontKnowOpt1+'"]') && tab.querySelector('.SecondOption option[value="'+DontKnowOpt2+'"]') ){
          tab.querySelector('.FirstOption option[value="'+DontKnowOpt1+'"]').selected = true;
          tab.querySelector('.SecondOption option[value="'+DontKnowOpt2+'"]').selected = true;
          tab.querySelectorAll('.SecondOption').forEach(function(select){ select.style.display='none'; });
          tab.querySelector('.SecondOption option[value="'+DontKnowOpt2+'"]').parentNode.style.display='block';
          tab.querySelector('.ThirdOptionDontKnowSize option[data-get="'+DontKnowOpt1+'+'+DontKnowOpt2+'"]').selected = true;
          // document.querySelectorAll('.variant-input-wrap[data-index="option2"] input[value="'+DontKnowOpt3+'"]').forEach(function(input){ input.dispatchEvent(eventFire); });
        }
      })
      document.querySelectorAll('.Know-size').forEach(function(tab){ 
        tab.querySelector('.tab-button.tab2').classList.add('active');
        tab.querySelector('.tab-button.tab1').classList.remove('active');
        tab.querySelector('[data-id="tab2"]').style.display='block';
        tab.querySelector('[data-id="tab1"]').style.display='none';
      })

      mainObj.querySelectorAll('.FormProduct form').forEach(function(form){
        if(!form.querySelector('[name="properties[_Size Calculator]"]')){
          form.innerHTML += '<input type="hidden" name="properties[_Size Calculator]" value="yes">';
        }
        if(!form.querySelector('[name="properties[_Measurement Calculator]"]')){
          form.innerHTML += '<input type="hidden" name="properties[_Measurement Calculator]" value="yes">';
        }
        if(!form.querySelector('[name="properties[_Measurement selected]"]')){
          form.innerHTML += '<input type="hidden" name="properties[_Measurement selected]" value="'+DontKnowOpt1+'+'+DontKnowOpt2+'='+DontKnowOpt3+'">'
        }
      })
    }
  }
  variantFieldSets(){
    var fieldSetsVariation = this.querySelectorAll('.pdp_variants_MN .variant-input-wrap'), mainObj = this, option1=[], option2=[], currentColorMatchOpt=[], currentOpt1, currentOpt2, currentCombo, currentID, EditionLabel;
    if(fieldSetsVariation){
      fieldSetsVariation.forEach(function(fieldset){
        if(fieldset.getAttribute('data-index') == 'option1'){
          fieldset.querySelectorAll('.variant-input input').forEach(function(variant){ option1.push(variant.value) });
        }else if(fieldset.getAttribute('data-index') == 'option2'){
          fieldset.querySelectorAll('.variant-input input').forEach(function(variant){ option2.push(variant.value) });
        }
        fieldset.querySelectorAll('.variant-input input').forEach(function(variant){ mainObj.variantChange(mainObj,variant,option1,option2); });
      })

      if(mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input:checked') && mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option2"] input:checked')){
        EditionLabel = mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input:checked').closest('.variant-input').querySelector('.ProductForm__Label').innerHTML;
        currentOpt1 = mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input:checked').value;
        currentOpt2 = mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option2"] input:checked').value;
      }else if(!mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input:checked') && mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option2"] input:checked')){
        currentOpt1 = mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"]').closest('.ColorItems').querySelector('.Selected-ColorName').innerHTML.trim();
        currentOpt2 = mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option2"] input:checked').value;
      }else if(mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input:checked') && !mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option2"] input:checked')){
        currentOpt1 = mainObj.querySelector('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input:checked').value;
      }
      
      if(currentOpt1 != undefined && currentOpt2 != undefined){ currentCombo = currentOpt1+' / '+currentOpt2; }
      else if(currentOpt1 != undefined && currentOpt2 == undefined){ currentCombo = currentOpt1 }

      if(mainObj.querySelectorAll('.variant__label .Limited-Edition.for-main-section').length > 0){
        mainObj.querySelectorAll('.variant__label .Limited-Edition.for-main-section').forEach(function(label){
          if(EditionLabel != null && EditionLabel != '' && EditionLabel != undefined && EditionLabel != 'undefined' ){
            label.innerHTML = EditionLabel.trim()+':';
          }
        })
      }

      if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"]')){
        document.querySelectorAll('#CustomStickyID .variant-input-wrap[data-index="option1"] input').forEach(function(item){ item.checked = false; })
        if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+currentOpt1+'"]')){
          document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+currentOpt1+'"]').checked = true;
        }
      }
      if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"]')){
        document.querySelectorAll('#CustomStickyID .variant-input-wrap[data-index="option2"] input').forEach(function(item){ item.checked = false; })
        if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+currentOpt2+'"]')){
          document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+currentOpt2+'"]').checked = true;
        }
      }

      if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]').hasAttribute('disabled')){
        mainObj.querySelectorAll('.product-single__variants.no-js.OwnDiv option').forEach(function(option){ option.removeAttribute('selected'); })
        mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]').setAttribute('selected','selected');
        currentID = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]').value;
        mainObj.querySelectorAll('.FormProduct').forEach(function(form){
          form.querySelector('[name="add"]').classList.add('disabled'); form.querySelector('[name="add"]').setAttribute('disabled','disabled');
          form.querySelector('span').innerHTML = 'SOLD OUT'; 
          if(form.querySelector('.FormProduct .klaviyo-bis-trigger')){
            form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.add('show'); 
            form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'block';
          }
        })
      }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]').hasAttribute('disabled')){
        mainObj.querySelectorAll('.product-single__variants.no-js.OwnDiv option').forEach(function(option){ option.removeAttribute('selected'); })
        mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]').setAttribute('selected','selected');
        currentID = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]').value;
        mainObj.querySelectorAll('.FormProduct').forEach(function(form){
          form.querySelector('[name="add"]').classList.remove('disabled'); form.querySelector('[name="add"]').removeAttribute('disabled');
          form.querySelector('span').innerHTML = 'ADD TO CART'; 
          if(form.querySelector('.FormProduct .klaviyo-bis-trigger')){
            form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.remove('show');
            form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'none';
          }
        })
      }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentCombo+'"]')){
        mainObj.querySelectorAll('.product-single__variants.no-js.OwnDiv option').forEach(function(option){ if(option.getAttribute('variant-title').includes(currentOpt1)){ currentColorMatchOpt.push(option); } })
        if(currentColorMatchOpt[0] == ''){
          currentID = currentColorMatchOpt[0].value;
        }
        mainObj.querySelectorAll('.FormProduct').forEach(function(form){
          form.querySelector('[name="add"]').classList.add('disabled'); form.querySelector('[name="add"]').setAttribute('disabled','disabled');
          form.querySelector('span').innerHTML = 'SOLD OUT'; 
          if(form.querySelector('.FormProduct .klaviyo-bis-trigger')){
            form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.add('show');
            form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'block';
          }
        })
      }

      const prepareCartesian = (arr1 = [], arr2 = []) => {
        const res = []; for(let i = 0; i < arr2.length; i++){ for(let j = 0; j < arr1.length; j++){ res.push(arr1[j] +' / '+ arr2[i]) } }; return res;
      };
      
      if(option1 && currentOpt2){ var possibleCombosSelectedSize = prepareCartesian(option1,[currentOpt2]); }
      else if(option1 && !currentOpt2){ var possibleCombosSelectedSize = [option1]; }

      if(option2 && currentOpt1){ var possibleCombosSelectedColor = prepareCartesian([currentOpt1],option2); }
      else if(!option2 && currentOpt1){ var possibleCombosSelectedColor = [currentOpt1]; }

      if(possibleCombosSelectedSize){
        possibleCombosSelectedSize.forEach(function(value){
          if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.remove('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').nextElementSibling.classList.remove('disabled');
              }
            }
          }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }
        })
      }
      if(possibleCombosSelectedColor){
        possibleCombosSelectedColor.forEach(function(value){
          if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.remove('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').nextElementSibling.classList.remove('disabled');
              }
            }
          }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }
        })
      }
      
      if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.discount){
        let discountMeta = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.discount;
        let discountMetaOff = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.staticOff;
        let crntVrntPrice = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').getAttribute('variant-price'),
            discount=100-parseInt(discountMeta),
            discountedPrice = crntVrntPrice * (discount/100),
            discountOff = 100*parseInt(discountMetaOff), 
            discountedPriceOff = parseInt(crntVrntPrice) - parseInt(discountOff);
        let DiscPriceWithMoney = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat),
            DiscPriceWithMoneyOff = theme.Currency.formatMoney(discountedPriceOff, theme.settings.moneyFormat),
            crntVrntPriceWithMoney = theme.Currency.formatMoney(crntVrntPrice, theme.settings.moneyFormat);
        mainObj.querySelectorAll('.product__price.discountedPrice').forEach(function(event){
          if(discountMeta > 0){
            event.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span class="discountedPrice" style="color:red;padding-left: 10px;"> ${DiscPriceWithMoney}</span>`
          }else if(discountMetaOff > 0){
            event.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span class="discountedPrice" style="color:red;padding-left: 10px;"> ${DiscPriceWithMoneyOff}</span>`
          }else{
              event.innerHTML = `${DiscPriceWithMoney}`
          }
        })
      }

      mainObj.querySelectorAll('.FormProduct [type="hidden"][name="form_type"]').forEach(function(form){
        form.value = currentID;
      })

      // this.URLUpdate(mainObj,currentID)
    }
  }
  variantChange(mainObj,variant,arrayOpt1,arrayOpt2){
    var option1, option2, currentVariant, currentID, EditionLabel, unavailFirst=[];
     variant.addEventListener('change',function(e){
      e.preventDefault();
      if((this.closest('.variant-input-wrap').getAttribute('data-index') == 'option1') && mainObj.querySelector('.pdp_variants_MN .variant-input-wrap[data-index="option2"]')){
        option1 = this.value;
        option2 = mainObj.querySelector('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input:checked').value;
        EditionLabel = this.closest('.variant-input').querySelector('.ProductForm__Label').innerHTML;
        mainObj.querySelectorAll('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option1"] input, .pdp_variants_MN.MBFrontMN .variant-input-wrap[data-index="option1"] input, .pdp_variants_MN.MBDrawerMN .variant-input-wrap[data-index="option1"] input').forEach(function(item){
          item.checked = false;
        });
        mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+option1+'"]').forEach(function(item){
          item.checked = true;
        })
        if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"]')){
          document.querySelectorAll('#CustomStickyID .variant-input-wrap[data-index="option1"] input').forEach(function(item){ item.checked = false; })
          document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+option1+'"]').checked = true;
        }
        mainObj.querySelectorAll('.Limited-Edition.for-main-section').forEach(function(label){
          label.innerHTML = EditionLabel+':';
        })
      }else if((this.closest('.variant-input-wrap').getAttribute('data-index') == 'option2') && mainObj.querySelector('.pdp_variants_MN .variant-input-wrap[data-index="option1"]')){
        option1 = mainObj.querySelector('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input:checked').value;
        option2 = this.value;
        mainObj.querySelectorAll('.pdp_variants_MN.DeskMNInit .variant-input-wrap[data-index="option2"] input, .pdp_variants_MN.MBFrontMN .variant-input-wrap[data-index="option2"] input, .pdp_variants_MN.MBDrawerMN .variant-input-wrap[data-index="option2"] input').forEach(function(item){
          item.checked = false;
        });
        mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+option2+'"]').forEach(function(item){
          item.checked = true;
        })
        if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"]')){
          document.querySelectorAll('#CustomStickyID .variant-input-wrap[data-index="option2"] input').forEach(function(item){ item.checked = false; })
          document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+option2+'"]').checked = true;
        }
      }else if((this.closest('.variant-input-wrap').getAttribute('data-index') == 'option1') && !mainObj.querySelector('.pdp_variants_MN .variant-input-wrap[data-index="option2"]')){
        option1 = this.value;
      }
      
      if(option1 != undefined && option2 != undefined){ currentVariant = option1+' / '+option2; }
      else if(option1 != undefined && option2 == undefined){ currentVariant = option1; }
      
      mainObj.querySelectorAll('.variant__label-info').forEach(function(tile){
        tile.innerHTML = option1;
      })

      const prepareCartesian = (arr1 = [], arr2 = []) => {
        const res = []; for(let i = 0; i < arr2.length; i++){ for(let j = 0; j < arr1.length; j++){ res.push(arr1[j] +' / '+ arr2[i]) } }; return res;
      };

      if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]').hasAttribute('disabled')){
        mainObj.querySelectorAll('.product-single__variants.no-js.OwnDiv option').forEach(function(option){ option.removeAttribute('selected'); })
        mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]').setAttribute('selected','selected');
        currentID = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]').value;
        let Target$StickyBtn = document.querySelector('.cv_sticky_atc_button');
        Target$StickyBtn.classList.add('disabled');Target$StickyBtn.disabled = true;Target$StickyBtn.innerHTML = 'SOLD OUT';
        mainObj.querySelectorAll('.FormProduct').forEach(function(form){
          form.querySelector('[name="add"]').classList.add('disabled'); form.querySelector('[name="add"]').setAttribute('disabled','disabled');
          form.querySelector('span').innerHTML = 'SOLD OUT';
          if(form.querySelector('.FormProduct .klaviyo-bis-trigger')){
            form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.add('show');
            form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'block';
          }
        });
      }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]').hasAttribute('disabled')){
        mainObj.querySelectorAll('.product-single__variants.no-js.OwnDiv option').forEach(function(option){ option.removeAttribute('selected'); })
        mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]').setAttribute('selected','selected');
        currentID = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]').value;
        let Target$StickyBtn = document.querySelector('.cv_sticky_atc_button');
        Target$StickyBtn.classList.remove('disabled');Target$StickyBtn.disabled = false;Target$StickyBtn.innerHTML = 'ADD TO CART';        
        mainObj.querySelectorAll('.FormProduct').forEach(function(form){
          form.querySelector('[name="add"]').classList.remove('disabled'); form.querySelector('[name="add"]').removeAttribute('disabled');
          form.querySelector('span').innerHTML = 'ADD TO CART'; 
          if(form.querySelector('.FormProduct .klaviyo-bis-trigger')){
            form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.remove('show');
            form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'none';
          }
        });
      }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+currentVariant+'"]')){
        mainObj.querySelectorAll('.product-single__variants.no-js.OwnDiv option').forEach(function(option,index){
          if(option.getAttribute('variant-title').includes(option1)){ unavailFirst.push(option); }
        });
        currentID = unavailFirst[0].value;
        let Target$StickyBtn = document.querySelector('.cv_sticky_atc_button');
        Target$StickyBtn.classList.add('disabled');Target$StickyBtn.disabled = true;Target$StickyBtn.innerHTML = 'UNAVAILABLE';        
        mainObj.querySelectorAll('.FormProduct').forEach(function(form){
          form.querySelector('[name="add"]').classList.add('disabled'); form.querySelector('[name="add"]').setAttribute('disabled','disabled');
          form.querySelector('span').innerHTML = 'UNAVAILABLE'; 
          if(form.querySelector('.FormProduct .klaviyo-bis-trigger')){
            form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.add('show');
            form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'block';
          }
        });
      }

      
      if(option2 && arrayOpt1){ var possibleCombosSelectedSize = prepareCartesian(arrayOpt1,[option2]); }
      else if(option2 && !arrayOpt1){ var possibleCombosSelectedSize = [arrayOpt1]; }

      if(option1 && arrayOpt2){ var possibleCombosSelectedColor = prepareCartesian([option1],arrayOpt2); }
      else if(option1 && !arrayOpt2){ var possibleCombosSelectedColor = [option1]; }

      if(possibleCombosSelectedSize){
        possibleCombosSelectedSize.forEach(function(value){
          if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.remove('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').nextElementSibling.classList.remove('disabled');
              }
            }
          }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              })
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }
        })
      }
      if(possibleCombosSelectedColor){
        possibleCombosSelectedColor.forEach(function(value){
          if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.remove('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').forEach(function(input){
                input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').classList.remove('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').nextElementSibling.classList.remove('disabled');
              }
            }
          }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]')){
            if(value.includes('/')){
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.add('disabled');
              }
            }else{
              mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').forEach(function(input){
                input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
              });
              if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]')){
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').classList.add('disabled');
                document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value+'"]').nextElementSibling.classList.add('disabled');
              }
            }
          }
        })
      }
       
      if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.discount){
        let discountMeta = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.discount;
        let discountMetaOff = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.staticOff;
        let crntVrntPrice = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').getAttribute('variant-price'),
            discount=100-parseInt(discountMeta),
            discountedPrice = crntVrntPrice * (discount/100),
            discountOff = 100*parseInt(discountMetaOff), 
            discountedPriceOff = parseInt(crntVrntPrice) - parseInt(discountOff);
        let DiscPriceWithMoney = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat),
            DiscPriceWithMoneyOff = theme.Currency.formatMoney(discountedPriceOff, theme.settings.moneyFormat),
            crntVrntPriceWithMoney = theme.Currency.formatMoney(crntVrntPrice, theme.settings.moneyFormat);
        mainObj.querySelectorAll('.product__price.discountedPrice').forEach(function(event){
          if(discountMeta > 0){
            event.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span class="discountedPrice" style="color:red;padding-left: 10px;"> ${DiscPriceWithMoney}</span>`
          }else if(discountMetaOff > 0){
            event.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span class="discountedPrice" style="color:red;padding-left: 10px;"> ${DiscPriceWithMoneyOff}</span>`
          }else{
              event.innerHTML = `${DiscPriceWithMoney}`
          }
        })
      }

      if(this.closest('fieldset').getAttribute('name') == 'Color'){
        var imagesData=document.querySelector('noscript.ProductImagesLoop').innerHTML,currentAlt=mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').getAttribute('alt-tag'),
            currentImgId =mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentID+'"]').dataset.imgid;
        var imagesHTML = new DOMParser().parseFromString(imagesData,'text/html').querySelectorAll('img');
        document.querySelector('.MediaSliderSingleBlk .MediaSliderMNwrpr').innerHTML = '';
        document.querySelector('.MediaSliderThumbMNBlk .MediaSliderThumbWrpr').innerHTML = '';
        imagesHTML.forEach(function(img){
          if(img.getAttribute('alt').trim() == currentAlt){
            document.querySelector('.MediaSliderSingleBlk .MediaSliderMNwrpr').innerHTML += '<div class="mediaWrprImgCnts swiper-slide">'+img.outerHTML+'</div>';
            document.querySelector('.MediaSliderThumbMNBlk .MediaSliderThumbWrpr').innerHTML += '<div class="mediaWrprImgCnts swiper-slide">'+img.outerHTML+'</div>';
          }else if(img.dataset.imgid == currentImgId){
            document.querySelector('.MediaSliderSingleBlk .MediaSliderMNwrpr').innerHTML += '<div class="mediaWrprImgCnts swiper-slide">'+img.outerHTML+'</div>';
            document.querySelector('.MediaSliderThumbMNBlk .MediaSliderThumbWrpr').innerHTML += '<div class="mediaWrprImgCnts swiper-slide">'+img.outerHTML+'</div>';
          }
        })
        var PDPMNThumbSliderChange, PDPMNSliderChange;
        if(PDPMNThumbSliderChange == undefined){
          if(window.innerWidth > 768){
            PDPMNThumbSliderChange = new Swiper(".MediaSliderThumbInit.swiper.mySwiper", {
              spaceBetween: 6,
              slidesPerView: 9,
              direction: "vertical",
              on: {
                init: (swiper) => {
                  let totalGap = swiper.passedParams.spaceBetween * (swiper.passedParams.slidesPerView - 1);
                  // let containerHeight = swiper.passedParams.slidesPerView * swiper.slides[0].clientHeight + totalGap;
                  let containerHeight  = document.querySelector('.MediaSliderMNwrpr').clientHeight;
                  swiper.el.style.height = containerHeight + 'px';
                }
              },
              mousewheel: true
            });
          }
        }
        if(PDPMNSliderChange == undefined){
          PDPMNSliderChange = new Swiper(".MediaSliderMNInit.swiper.mySwiper", {
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", },
            thumbs: { swiper: PDPMNThumbSliderChange, }
          });
        }
      }
      
      mainObj.URLUpdate(mainObj,currentID)
    })
  }
  URLUpdate(mainObj,id){
    var newurl;
    if(id !== undefined){
      if(!window.location.href.includes('?')){
        newurl = window.location.href + '?variant=' + id;
      }else if(window.location.href.includes('?') && !window.location.href.includes('&')){
        newurl = window.location.href.split('?variant')[0] + '?variant=' + id;
      }else if(window.location.href.includes('?') && window.location.href.includes('&')){
        newurl = window.location.href.split('?variant')[0] + '?variant=' + id +'&'+window.location.href.split(/&(.*)/s)[1];
      }
      mainObj.querySelectorAll('.FormProduct [type="hidden"][name="form_type"]').forEach(function(form){
        form.value = id;
      })
    }

    window.history.replaceState({path: newurl}, '', newurl);
    this.renderSectionPDPMN(mainObj,newurl)
  }
  async renderSectionPDPMN(mainObj,url){
    if(url !== undefined){
      var pdpUpdateAll = await fetch(url).then((res) => res.text()), $pdpUpdateAll = UTILS.convertStringToHTML(pdpUpdateAll);
        // Stock Updates
        if($pdpUpdateAll.querySelector('.product-block--sales-point')){
          var stockUpdate = $pdpUpdateAll.querySelector('.product-block--sales-point');
          mainObj.querySelectorAll('.product-block--sales-point').forEach(function(stock){ stock.outerHTML = stockUpdate.outerHTML; })
        }

        if($pdpUpdateAll.querySelector('.cv_sticky_atc .variant__label-info')){
          var variantLabelUpdate = $pdpUpdateAll.querySelector('.cv_sticky_atc .variant__label-info').innerHTML;
          document.querySelector('.cv_sticky_atc .variant__label-info').innerHTML = variantLabelUpdate;
        }
      
    }
  }
  URLUpdateSticky(mainObj,id){
    var newurl;
    if(id !== undefined){
      if(!window.location.href.includes('?')){
        newurl = window.location.href + '?variant=' + id;
      }else if(window.location.href.includes('?') && !window.location.href.includes('&')){
        newurl = window.location.href.split('?variant')[0] + '?variant=' + id;
      }else if(window.location.href.includes('?') && window.location.href.includes('&')){
        newurl = window.location.href.split('?variant')[0] + '?variant=' + id +'&'+window.location.href.split(/&(.*)/s)[1];
      }
      mainObj.querySelectorAll('.FormProduct [type="hidden"][name="form_type"]').forEach(function(form){
        form.value = id;
      })
    }

    window.history.replaceState({path: newurl}, '', newurl);
    this.renderSectionPDPMNSticky(mainObj,newurl)
  }  
  async renderSectionPDPMNSticky(mainObj,url){
    if(url !== undefined){
      var pdpUpdateAll = await fetch(url).then((res) => res.text()), $pdpUpdateAll = UTILS.convertStringToHTML(pdpUpdateAll);

        // Variant Title Updates
        var variantTitleUpdate = $pdpUpdateAll.querySelector('.pdp_variants_MN.DeskMNInit .variant__label-info');
        mainObj.querySelectorAll('.variant__label-info').forEach(function(tile){ tile.innerHTML = variantTitleUpdate.innerHTML; })
      
        // Image Updates
        var imageUpdate = $pdpUpdateAll.querySelector('.CstmPDPNewMediaMN').innerHTML;
        mainObj.querySelector('.CstmPDPNewMediaMN').innerHTML = imageUpdate; 

        var PDPMNThumbSliderChange, PDPMNSliderChange;
        if(PDPMNThumbSliderChange == undefined){
          if(window.innerWidth > 768){
            PDPMNThumbSliderChange = new Swiper(".MediaSliderThumbInit.swiper.mySwiper", {
              spaceBetween: 6,
              slidesPerView: 9,
              direction: "vertical",
              on: {
                init: (swiper) => {
                  let totalGap = swiper.passedParams.spaceBetween * (swiper.passedParams.slidesPerView - 1);
                  // let containerHeight = swiper.passedParams.slidesPerView * swiper.slides[0].clientHeight + totalGap;
                  let containerHeight  = document.querySelector('.MediaSliderMNwrpr').clientHeight;
                  swiper.el.style.height = containerHeight + 'px';
                }
              },
              mousewheel: true
            });
          }
        }
        if(PDPMNSliderChange == undefined){
          PDPMNSliderChange = new Swiper(".MediaSliderMNInit.swiper.mySwiper", {
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", },
            thumbs: { swiper: PDPMNThumbSliderChange, }
          });
        }

        // Stock Updates
        if($pdpUpdateAll.querySelector('.product-block--sales-point')){
          var stockUpdate = $pdpUpdateAll.querySelector('.product-block--sales-point');
          mainObj.querySelectorAll('.product-block--sales-point').forEach(function(stock){ stock.outerHTML = stockUpdate.outerHTML; })
        }

        if($pdpUpdateAll.querySelector('.cv_sticky_atc .variant__label-info')){
          var variantLabelUpdate = $pdpUpdateAll.querySelector('.cv_sticky_atc .variant__label-info').innerHTML;
          document.querySelector('.cv_sticky_atc .variant__label-info').innerHTML = variantLabelUpdate;
        }
      
    }
  }  
  stickyFormSubmitAJAX(mainObj, target){
    target.preventDefault();
    let formAddToCartId = mainObj.querySelector('.FormProduct form[action$="/cart/add"] [name="form_type"]').value.toString(), formData;
    if(document.body.getAttribute('CountryEnabled') == null){
      formData = {id: formAddToCartId,quantity: 1};
    }else{
      formData = {id: formAddToCartId,quantity: 1,properties:{'_CountryEnabled': 'USA'}};
    }
    UTILS.addItemsToCart([ formData ]);
  }
  stickyCart(mainObj){
    var option1,option2, currentCombo, currentId, unavailFirst=[],variant,firstOpt=[], secondOpt=[], currentLabel;
    const prepareCartesian=(arr1=[], arr2=[]) => { const res=[]; for(let i=0; i < arr2.length; i++){for(let j = 0; j < arr1.length; j++){res.push(arr1[j] +' / '+ arr2[i])}}; return res; };
    if(document.querySelectorAll('#CustomStickyID fieldset').length > 0){
      document.querySelectorAll('#CustomStickyID fieldset').forEach(function(fieldset){
        fieldset.querySelectorAll('input').forEach(function(input){
          if(fieldset.getAttribute('data-index') == 'option1'){
            firstOpt.push(input.value);
          }else if(fieldset.getAttribute('data-index') == 'option2'){
            secondOpt.push(input.value);
          }
          input.addEventListener('change',function(e){
            if(this.closest('.variant-input-wrap').getAttribute('data-index') == 'option1'){
              option1 = this.value;
              option2 = document.querySelector('.variant-input-wrap.StickyCustomElem[data-index="option2"] input:checked').value;
              currentLabel = this.closest('.variant-input').querySelector('.ProductForm__Label').innerHTML;
              document.querySelector('.cv_sticky_atc_colorswatch [data-color-label]').innerHTML = option1;
            }else if(this.closest('.variant-input-wrap').getAttribute('data-index') == 'option2'){
              option2 = this.value;
              option1 = document.querySelector('.variant-input-wrap.StickyCustomElem[data-index="option1"] input:checked').value;
            }
            currentCombo = option1+' / '+option2;
            if(document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]') && document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]').hasAttribute('disabled')){
              currentId = document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]').getAttribute('stvarinatid');
              document.querySelectorAll('.StickyHiddenSelector option').forEach(function(option){ option.removeAttribute('selected'); })
              document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]').setAttribute('selected','selected');
              document.querySelector('.cv_sticky_atc_button').innerHTML = 'SOLD OUT';
              document.querySelector('.cv_sticky_atc_button').setAttribute('disabled','disabled');
              document.querySelector('.cv_sticky_atc_button').classList.add('disabled');
              if(mainObj){
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option1"] input').forEach(function(input){ input.checked = false });
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option1"] input[value="'+option1+'"]').forEach(function(input){ input.checked = true });
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option2"] input').forEach(function(input){ input.checked = false });
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option2"] input[value="'+option2+'"]').forEach(function(input){ input.checked = true });
                mainObj.querySelectorAll('.FormProduct').forEach(function(form){
                  form.querySelector('[name="add"]').classList.add('disabled'); form.querySelector('[name="add"]').setAttribute('disabled','disabled');
                  form.querySelector('span').innerHTML = 'SOLD OUT'; form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.add('show');form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'block';
                });
              }
            }else if(document.querySelector('.StickyHiddenSelector option[stvarianttitle="'+currentCombo+'"]') && !document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]').hasAttribute('disabled')){
              currentId = document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]').getAttribute('stvarinatid');
              document.querySelectorAll('.StickyHiddenSelector option').forEach(function(option){ option.removeAttribute('selected'); })
              document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]').setAttribute('selected','selected');
              document.querySelector('.cv_sticky_atc_button').innerHTML = 'ADD TO CART';
              document.querySelector('.cv_sticky_atc_button').removeAttribute('disabled');
              document.querySelector('.cv_sticky_atc_button').classList.remove('disabled');
              if(mainObj){
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option1"] input').forEach(function(input){ input.checked = false });
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option1"] input[value="'+option1+'"]').forEach(function(input){ input.checked = true });
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option2"] input').forEach(function(input){ input.checked = false });
                mainObj.querySelectorAll('.variant-input-wrap[data-index="option2"] input[value="'+option2+'"]').forEach(function(input){ input.checked = true });
                mainObj.querySelectorAll('.FormProduct').forEach(function(form){
                  form.querySelector('[name="add"]').classList.remove('disabled'); form.querySelector('[name="add"]').removeAttribute('disabled');
                  form.querySelector('span').innerHTML = 'ADD TO CART'; form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.remove('show');form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'none';
                });
              }
            }else if(!document.querySelector('.StickyHiddenSelector  option[stvarianttitle="'+currentCombo+'"]')){
              document.querySelectorAll('.StickyHiddenSelector option').forEach(function(option,index){
                if(option.getAttribute('stvarianttitle').includes(option1)){ unavailFirst.push(option); }
              });
              currentId = unavailFirst[0].getAttribute('stvarinatid');
              document.querySelector('.cv_sticky_atc_button').innerHTML = 'UNAVAILABLE';
              document.querySelector('.cv_sticky_atc_button').setAttribute('disabled','disabled');
              document.querySelector('.cv_sticky_atc_button').classList.add('disabled');
              if(mainObj){
                mainObj.querySelectorAll('.FormProduct').forEach(function(form){
                  form.querySelector('[name="add"]').classList.add('disabled'); form.querySelector('[name="add"]').setAttribute('disabled','disabled');
                  form.querySelector('span').innerHTML = 'UNAVAILABLE'; form.querySelector('.FormProduct .klaviyo-bis-trigger').classList.add('show');form.querySelector('.FormProduct .klaviyo-bis-trigger').style.display = 'block';
                });
              }
            }
            
            if(mainObj){ mainObj.URLUpdateSticky(mainObj,currentId); }

            if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentId+'"]').dataset.discount){
              let discountMeta = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentId+'"]').dataset.discount;
              let discountMetaOff = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentId+'"]').dataset.staticOff;
              let crntVrntPrice = mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[value="'+currentId+'"]').getAttribute('variant-price'),
                  discount=100-parseInt(discountMeta),
                  discountedPrice = crntVrntPrice * (discount/100),
                  discountOff = 100*parseInt(discountMetaOff), 
                  discountedPriceOff = parseInt(crntVrntPrice) - parseInt(discountOff);
              let DiscPriceWithMoney = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat),
                  DiscPriceWithMoneyOff = theme.Currency.formatMoney(discountedPriceOff, theme.settings.moneyFormat),
                  crntVrntPriceWithMoney = theme.Currency.formatMoney(crntVrntPrice, theme.settings.moneyFormat);
              mainObj.querySelectorAll('.product__price.discountedPrice').forEach(function(event){
                if(discountMeta > 0){
                  event.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span class="discountedPrice" style="color:red;padding-left: 10px;"> ${DiscPriceWithMoney}</span>`
                }else if(discountMetaOff > 0){
                  event.innerHTML = `<s>${crntVrntPriceWithMoney}</s><span class="discountedPrice" style="color:red;padding-left: 10px;"> ${DiscPriceWithMoneyOff}</span>`
                }else{
                    event.innerHTML = `${DiscPriceWithMoney}`
                }
              })
            }         
           
            var combosBasedOnSize = prepareCartesian(firstOpt,[option2]), combosBasedOnColor = prepareCartesian([option1],secondOpt);
            combosBasedOnSize.forEach(function(value){
              if(mainObj){
                if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
                  mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                    input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
                  })
                  if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.add('disabled');
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.add('disabled');
                  }
                }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
                  mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                    input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
                  })
                  if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.remove('disabled');
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.remove('disabled');
                  }
                }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]')){
                  mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').forEach(function(input){
                    input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
                  })
                  if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]')){
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').classList.add('disabled');
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option1"] input[value="'+value.split('/')[0].trim()+'"]').nextElementSibling.classList.add('disabled');
                  }
                }
              }
            })
            combosBasedOnColor.forEach(function(value){
              if(mainObj){
                if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
                  mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                    input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
                  });
                  if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.add('disabled');
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.add('disabled');
                  }
                }else if(mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]') && !mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]').hasAttribute('disabled')){
                  mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                    input.classList.remove('disabled'); input.nextElementSibling.classList.remove('disabled');
                  });
                  if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.remove('disabled');
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.remove('disabled');
                  }
                }else if(!mainObj.querySelector('.product-single__variants.no-js.OwnDiv option[variant-title="'+value+'"]')){
                  mainObj.querySelectorAll('.pdp_variants_MN .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').forEach(function(input){
                    input.classList.add('disabled'); input.nextElementSibling.classList.add('disabled');
                  });
                  if(document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]')){
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').classList.add('disabled');
                    document.querySelector('#CustomStickyID .variant-input-wrap[data-index="option2"] input[value="'+value.split('/')[1].trim()+'"]').nextElementSibling.classList.add('disabled');
                  }
                }
              }
            })
          })
        })
      })
    }
  }
  knowSizeSelect(mainObj, select){    
    var Bust_Inches = select.target.value;
    select.target.closest('.SelectorOuter').querySelectorAll('.SecondOption').forEach(function(BustSize){
      if(BustSize.hasAttribute('data-handle')){ 
        BustSize.style.display = 'none'; 
        BustSize.classList.add('Not_Active'); BustSize.classList.remove('Active_Right_Now'); 
        if(BustSize.getAttribute('data-handle') == Bust_Inches){ BustSize.style.display = 'block'; BustSize.querySelector('option[value="none"]').selected = true; BustSize.classList.remove('Not_Active'); BustSize.classList.add('Active_Right_Now'); }; 
      }
      BustSize.querySelector('option[value="none"]').selected = true;
    })
    select.target.closest('.SelectorOuter').querySelectorAll('.EBSelect').forEach(function(EBSize){
      EBSize.querySelector('option[value="none"]').selected = true;
    })
  }
  knowSizeSecondSelect(mainObj, select){
    var SecondValue = select.target.value, FirstValue, ThirdValue, ComboValue, KnowSizeValue, DontKnowSizeValue;
    select.target.closest('.SelectorOuter').querySelectorAll('.FirstOption').forEach(function(FirstOpt){ FirstValue = FirstOpt.value; })
    ComboValue = FirstValue+'+'+SecondValue;
    select.target.closest('.SelectorOuter').querySelectorAll('.EBSelect').forEach(function(EBSize){
      EBSize.querySelector('option[data-get="'+ComboValue+'"]').selected = true;
      ThirdValue = EBSize.value.split('=')[1];
      if(EBSize.classList.contains('ThirdOptionDontKnowSize')){
        DontKnowSizeValue = EBSize.value.replace('=','@') 
        mainObj.querySelectorAll('.FormProduct form').forEach(function(form){
          if(!form.querySelector('[name="properties[_Size Calculator]"]')){
            form.innerHTML += '<input type="hidden" name="properties[_Size Calculator]" value="yes">';
          }
          if(!form.querySelector('[name="properties[_Measurement Calculator]"]')){
            form.innerHTML += '<input type="hidden" name="properties[_Measurement Calculator]" value="yes">';
          }
          if(form.querySelector('[name="properties[_Traditional Calculator]"]')){ form.querySelector('[name="properties[_Traditional Calculator]"]').remove(); }
          if(!form.querySelector('[name="properties[_Measurement selected]"]')){
            form.innerHTML += '<input type="hidden" name="properties[_Measurement selected]" value="'+EBSize.value+'">'
          }else{
            form.querySelector('[name="properties[_Measurement selected]"]').value = EBSize.value;
          }
          if(form.querySelector('[name="properties[_Size selected]"]')){ form.querySelector('[name="properties[_Size selected]"]').remove(); }
        })
      }else if(EBSize.classList.contains('ThirdOptionKnowSize')){ 
        KnowSizeValue = EBSize.value.replace('=','@'); 
        mainObj.querySelectorAll('.FormProduct form').forEach(function(form){
          if(!form.querySelector('[name="properties[_Size Calculator]"]')){
            form.innerHTML += '<input type="hidden" name="properties[_Size Calculator]" value="yes">';
          }
          if(!form.querySelector('[name="properties[_Traditional Calculator]"]')){
            form.innerHTML += '<input type="hidden" name="properties[_Traditional Calculator]" value="yes">';
          }
          if(form.querySelector('[name="properties[_Measurement Calculator]"]')){ form.querySelector('[name="properties[_Measurement Calculator]"]').remove(); }
          if(!form.querySelector('[name="properties[_Size selected]"]')){
            form.innerHTML += '<input type="hidden" name="properties[_Size selected]" value="'+EBSize.value+'">'
          }else{
            form.querySelector('[name="properties[_Size selected]"]').value = EBSize.value;
          }
          if(form.querySelector('[name="properties[_Measurement selected]"]')){ form.querySelector('[name="properties[_Measurement selected]"]').remove(); }
        })
      }
      document.cookie = "KnowSizeValue="+KnowSizeValue+"; expires=Fri, 31 Dec 9999 23:59:59 GMT";
      document.cookie = "DontKnowSizeValue="+DontKnowSizeValue+"; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    })
    const eventFire = new Event("change", { bubbles: true });
    document.querySelectorAll('.variant-input-wrap[data-index="option2"] input[value="'+ThirdValue+'"]').forEach(function(input){
      input.dispatchEvent(eventFire);
    })
  }
  drawerMobileInit(mainObj, target){
    target.preventDefault();
    document.body.classList.add('body_Mobile_Dropdown');
    mainObj.querySelector('.MobileDropdown').classList.add('Mobile_Dropdown');
  }
  drawerMobileClose(mainObj, target){
    target.preventDefault();
    document.body.classList.remove('body_Mobile_Dropdown');
    mainObj.querySelector('.MobileDropdown').classList.remove('Mobile_Dropdown');
  }
  howToMeasureInit(mainObj, target){
    target.preventDefault();
    document.querySelector('.Append-measure').style.display = 'block';
    document.body.className += ' sizechartguide HowMeasure_design';
  }
  howToMeasureClose(mainObj, target){
    target.preventDefault();
    document.querySelector('.Append-measure').style.display = 'none';
    document.body.classList.remove('sizechartguide', 'HowMeasure_design');
  }
  sizeChartPop(mainObj, event){
    event.preventDefault();
    document.body.classList.add('sizePDPpop')
    document.querySelector('.SizeChartContentMN').classList.add('active');
  }
  closeSize(mainObj , event){
    event.preventDefault();
    document.body.classList.remove('sizePDPpop')
    document.querySelector('.SizeChartContentMN').classList.remove('active');
  }
}
customElements.define('product-main-grid', ProductMainGrid)